import { application } from "./controllers/application";

import ExtendedNestedForm from "./controllers/extended_nested_form_controller";
application.register("extended-nested-form", ExtendedNestedForm);

import ExternalControlsNestedForm from "./controllers/external_controls_nested_form_controller";
application.register(
  "external-controls-nested-form",
  ExternalControlsNestedForm,
);

import WithCounterNestedForm from "./controllers/with_counter_nested_form_controller";
application.register("with-counter-nested-form", WithCounterNestedForm);

import Sortable from "stimulus-sortable";
application.register("sortable", Sortable);
